
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'ResetPassword',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
         processed: false,
      }
   },
   methods: {
      async action() {
         this.processing = true
         try {
            await Api.resetUserPassword(this.editingItem.Id)
            this.processing = false
            this.processed = true
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
   },
})
